import { render, staticRenderFns } from "./app-logo.vue?vue&type=template&id=5c381efb&scoped=true"
import script from "./app-logo.vue?vue&type=script&lang=js"
export * from "./app-logo.vue?vue&type=script&lang=js"
import style0 from "./app-logo.vue?vue&type=style&index=0&id=5c381efb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c381efb",
  null
  
)

/* custom blocks */
import block0 from "./app-logo.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports